import React, {useEffect, useState} from 'react';
import {getCookie, setCookie} from "../../util/cookie";
import PopNotification from "./PopNotification";
import api from "../../util/api";
import spEventImag from "../../_asset/banner/pop_event.jpg"
import Btn from "../_custom/button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faXmark } from '@fortawesome/free-solid-svg-icons';

export interface noticeListInterface {
    id: number,
    title: string,
    content: string,
    written_at: string,
}
export interface noticeApiInterface {
    total: number,
    notices: noticeListInterface[]
}

function CookieSetComponent() {
    const [noticeList, setNoticeList] = useState<noticeListInterface[]>([])


    useEffect(()=> {
        api(`/api/site/notices/?kind=popup`)
            .then(res => res.json())
            .then((data: noticeApiInterface) => {
                setNoticeList(data.notices)
            })
    }, [])

    return (
        <>
            {/* <EventPopupDialog/> */}
            {
                noticeList.length ? <ComponentParent cookieNameList={noticeList}/> : <></>
            }
        </>
    )
}

export default CookieSetComponent;

function ComponentParent({cookieNameList}: {cookieNameList: noticeListInterface[]}){
    // 쿠키는 자식이 렌더되기 전에 만들어져 있어야 한다.
    // PopNotification 이 첫 렌더에서 쿠키를 읽어 노출 여부를 정하기 때문에,
    // 이 계산이 effect 로 밀리면 첫 방문자에게 카드 없는 오버레이만 뜬다.
    function countAdPopupCookies(){
        let count: number = 0
        for(let value of cookieNameList){
            if(!getCookie(`ad_${value.id}`)){
                setCookie(`ad_${value.id}`, `1`)
            }

            if(getCookie(`ad_${value.id}`) == `1`){
                count++;
            }
        }
        return count
    }

    const [showLength, setShowLength] = useState<number>(countAdPopupCookies)
    const [dialogAreaShow, setDialogAreaShow] = useState<boolean>(showLength > 0)
    const [allClosing, setAllClosing] = useState<boolean>(false)

    useEffect(()=> {
        setDialogAreaShow(showLength > 0)
    }, [showLength])

    // 팝업이 떠 있는 동안 배경 스크롤을 잠근다.
    useEffect(()=> {
        if(!dialogAreaShow) return

        const prevOverflow = window.document.body.style.overflow
        window.document.body.style.overflow = 'hidden'

        return ()=> {
            window.document.body.style.overflow = prevOverflow || 'visible'
        }
    }, [dialogAreaShow])

    function handleCloseAll(){
        setAllClosing(true)
        setTimeout(()=> {
            setShowLength(0)
            setDialogAreaShow(false)
        }, 250)
    }

    return (
        <>
            {
                dialogAreaShow ?
                    <div className={`pn-dialog${allClosing ? " pn-dialog-closing" : ""}`} >
                        <div className={"pn-toolbar"}>
                            {
                                showLength > 1
                                    ? <Btn color={"yellow"} onClick={handleCloseAll}>전체 닫기</Btn>
                                    : <></>
                            }
                        </div>

                        <div className={"pn-track"}>
                            {
                                cookieNameList.map((list)=> (
                                    <PopNotification key={list.id}
                                                     popupNumber={list.id}
                                                     popupContent={list}
                                                     setShowLength={setShowLength}/>
                                ))
                            }
                        </div>
                    </div>
                    :<></>
            }
        </>
    )
}

function EventPopupDialog(){
    const [show, setShow] = useState<boolean>(setSpecialEventPopState)

    function setSpecialEventPopState(){
        const eventCookie = getCookie('sp_event_3')
        if(!eventCookie){
            const dayAgo = new Date(new Date().getTime() + (60000 * 60 * 2))
            setCookie(`sp_event_3`, "1", {
                path: '/', expires: dayAgo
            })
            return true;
        }else{
            return false;
        }
    }
    function handleCookieDeleteClose(){
        setShow(false)
        window.document.body.style.overflow = 'visible'

        const dayAgo = new Date(new Date().getTime() + (60000 * 60 * 2))
        setCookie(`sp_event_3`, "0", {
            path: '/', expires: dayAgo
        })
    }

    useEffect(()=> {
        const eventCookie = getCookie('sp_event_3')
        if(eventCookie == `1`){
            setShow(true)
            window.document.body.style.overflow = 'hidden'
        }else{
            setShow(false)
            window.document.body.style.overflow = 'visible'
        }

    }, [])

    return (
        show
            ? <div className={'pop-event-dialog'}>
                <div className={'pop-event-body'}>
                    <div className={'close-event'} onClick={e=> {
                        setShow(false)
                        window.document.body.style.overflow = 'visible'
                    }}>
                        <FontAwesomeIcon icon={faXmark} size={`2x`}/>
                    </div>
                    <img src={spEventImag} alt="sp"/>
                    <div className="btn-area">
                        <Btn color={"yellow"} onClick={handleCookieDeleteClose}>2시간 안보이기</Btn>
                    </div>
                </div>
            </div>
            : <></>

    )
}
